import React from 'react';
import { useFormikContext } from 'formik';
import { FormControl, FormHelperText, FormLabel, Grid, MenuItem, Select } from '@mui/material';
import PipelineSelect from '@/components/selects/PipelineSelect';
import { usePipelineContext } from '@/context/pipelineContext';

export const PipelineStageSelect = () => {
	const { values, setFieldValue, touched, errors } = useFormikContext();
	const { stages = [] } = usePipelineContext(values.pipelineId);

	const getError = (field) => touched[field] && Boolean(errors[field]);
	const getErrorMessage = (field) => touched[field] && errors[field];

	//Need to make sure I reset the stage...
	const handlePipelineChange = (pipelineId) => {
		setFieldValue('pipelineId', pipelineId);
		setFieldValue('stageId', '');
	};

	return (
		<>
			<Grid size={12}>
				<FormLabel required>Pipeline</FormLabel>
				<PipelineSelect
					value={values.pipelineId}
					onChange={handlePipelineChange}
					error={getError('pipelineId')}
					hideProspectStage
				/>
				<FormHelperText error={getError('pipelineId')}>
					{getErrorMessage('pipelineId')}
				</FormHelperText>
			</Grid>

			<Grid size={12}>
				<FormLabel required>Stage</FormLabel>
				<FormControl fullWidth error={getError('stageId')}>
					<Select
						value={values.stageId}
						onChange={(event) => setFieldValue('stageId', event.target.value)}
						disabled={!values.pipelineId || stages.length === 0}
						displayEmpty
					>
						<MenuItem value='' disabled>
							Select a stage
						</MenuItem>
						{stages.map((stage) => (
							<MenuItem key={stage.id} value={stage.id}>
								{stage.label || stage.name || stage.id}
							</MenuItem>
						))}
					</Select>
					<FormHelperText>{getErrorMessage('stageId')}</FormHelperText>
				</FormControl>
			</Grid>
		</>
	);
};
